import {
  FA_UNDERWRITER_DISABLED_MESSAGE,
  NON_FA_UNDERWRITER_DISABLED_MESSAGE,
  offerMessage,
} from 'features/help/constants';

export interface UnderwriterAlertInput {
  productName: string;
  isEnabled: boolean;
  isNonFaUnderwriter: boolean;
  isAgentNetAdmin: boolean;
}

export interface UnderwriterAlert {
  message: string;
  // Only an AgentNet Administrator can turn the product on, everyone else is told who to ask.
  showEnableAction: boolean;
}

export function getUnderwriterAlert({
  productName,
  isEnabled,
  isNonFaUnderwriter,
  isAgentNetAdmin,
}: UnderwriterAlertInput): UnderwriterAlert | null {
  if (isEnabled) {
    return null;
  }

  const disabledMessage = (
    isNonFaUnderwriter ? NON_FA_UNDERWRITER_DISABLED_MESSAGE : FA_UNDERWRITER_DISABLED_MESSAGE
  ).replace('{ProductName}', productName);

  return {
    message: isAgentNetAdmin ? disabledMessage : `${disabledMessage} ${offerMessage['nonAdmin']}`,
    showEnableAction: isAgentNetAdmin,
  };
}
